import { render, staticRenderFns } from "./CreateHotel.vue?vue&type=template&id=3c8d12ef&scoped=true"
import script from "./CreateHotel.vue?vue&type=script&lang=js"
export * from "./CreateHotel.vue?vue&type=script&lang=js"
import style0 from "./CreateHotel.vue?vue&type=style&index=0&id=3c8d12ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d12ef",
  null
  
)

export default component.exports